import { TopToolbar, FilterButton, CreateButton, ExportButton } from 'react-admin';

interface ListActionsProps {
  hasCreate?: boolean;
  hasExport?: boolean;
  hasFilter?: boolean;
}

export const ListActions = ({
  hasCreate = true,
  hasExport = false,
  hasFilter = true,
}: ListActionsProps) => (
  <TopToolbar>
    {hasFilter && <FilterButton />}
    {hasCreate && <CreateButton />}
    {hasExport && <ExportButton />}
  </TopToolbar>
);
